// AJAX Add to Cart and Cart Drawer

// Temporary Lighthouse guard: when running headless Lighthouse (or when
// the `?lighthouse` URL param is present) set a global flag to skip
// heavy client-side storefront fetches. This keeps audits from timing out.
try {
  const urlParams = typeof URLSearchParams !== 'undefined' ? new URLSearchParams(window.location.search) : null;
  const isLighthouse = (urlParams && urlParams.has('lighthouse')) || (/HeadlessChrome|Chrome\/\d+\.\d+.*headless/i.test(navigator.userAgent || ''));
  if (isLighthouse) window.__SKIP_HEAVY_CLIENT_FETCHES__ = true;
} catch (e) {}

function __shouldSkipHeavyFetches() {
  return !!(window.__SKIP_HEAVY_CLIENT_FETCHES__);
}

// Defer and lazy-load Tawk (chat) and other heavy 3rd-party embed scripts
// Removes any existing Tawk embed scripts and loads them after user interaction
// or during idle. Skips entirely during Lighthouse runs.
function __deferThirdPartyEmbeds() {
  if (__shouldSkipHeavyFetches()) return; // don't load during audits
  try {
    var scripts = Array.prototype.slice.call(document.querySelectorAll('script'));
    var toLoad = [];
    scripts.forEach(function(s) {
      var src = s.getAttribute && s.getAttribute('src');
      if (!src) return;
      // target Tawk and other known heavy vendor embeds by host
      if (/embed\.tawk\.to|twk-chunk|tawk-chunk/.test(src)) {
        toLoad.push(src);
        s.parentNode && s.parentNode.removeChild(s);
      }
    });
    if (!toLoad.length) return;

    var loaded = false;
    function loadThirdParties() {
      if (loaded) return; loaded = true;
      toLoad.forEach(function(u) {
        var sc = document.createElement('script');
        sc.src = u;
        sc.async = true;
        document.head.appendChild(sc);
      });
    }

    // load on first user interaction
    ['pointerdown','touchstart','keydown','scroll'].forEach(function(ev) {
      window.addEventListener(ev, loadThirdParties, { once: true, passive: true });
    });

    // fallback: load when browser is idle or after short timeout
    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadThirdParties, { timeout: 3000 });
    } else {
      setTimeout(loadThirdParties, 3000);
    }
  } catch (e) {
    // noop
  }
}

// Trigger deferred embeds once DOM ready (but they will actually load
// only on user interaction or idle)
document.addEventListener('DOMContentLoaded', __deferThirdPartyEmbeds);

document.addEventListener('DOMContentLoaded', function() {

  // Handle all Add to Cart forms
  var addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
  addToCartForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function(data) {
        updateCartCount();
        // showCartDrawer();
        // Show 'item added' message
        var msg = document.createElement('div');
        msg.textContent = 'Item added to cart!';
        msg.style.position = 'fixed';
        msg.style.top = '24px';
        msg.style.right = '24px';
        msg.style.background = '#2a0845';
        msg.style.color = '#ffe66f';
        msg.style.padding = '1rem 2rem';
        msg.style.borderRadius = '16px';
        msg.style.boxShadow = '0 2px 16px #b23cf0';
        msg.style.fontWeight = '700';
        msg.style.zIndex = '99999';
        document.body.appendChild(msg);
        setTimeout(function() { msg.remove(); }, 2200);
      })
      .catch(function(error) {
        alert('Could not add item to cart. Please try again.');
        console.error(error);
      });
    });
  });

  // Update cart count badge
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Ensure both desktop and mobile badges exist, update both
        var desktopLink = document.querySelector('.cart-icon-link');
        var mobileLink = document.querySelector('.mobile-cart');
        var desktopBadge = desktopLink ? desktopLink.querySelector('.cart-count-badge') : null;
        var mobileBadge = mobileLink ? mobileLink.querySelector('.cart-count-badge') : null;

        if (!desktopBadge && desktopLink) {
          desktopBadge = document.createElement('span');
          desktopBadge.className = 'cart-count-badge';
          desktopBadge.style.cssText = 'position:absolute; top:-8px; right:-8px; background:#ffe66f; color:#2a0845; border-radius:50%; padding:2px 7px; font-size:0.95rem; font-weight:700; box-shadow:0 0 8px #b23cf0; display:none;';
          desktopBadge.textContent = '0';
          desktopLink.appendChild(desktopBadge);
        }

        if (!mobileBadge && mobileLink) {
          mobileBadge = document.createElement('span');
          mobileBadge.className = 'cart-count-badge';
          mobileBadge.style.cssText = 'margin-left:6px; background:#ffe66f; color:#2a0845; border-radius:12px; padding:2px 6px; font-size:0.85rem; font-weight:700; box-shadow:0 0 8px #b23cf0; display:none; vertical-align:super;';
          mobileBadge.textContent = '0';
          mobileLink.appendChild(mobileBadge);
        }

        [desktopBadge, mobileBadge].forEach(function(b) {
          if (!b) return;
          b.textContent = cart.item_count;
          b.style.display = cart.item_count > 0 ? 'inline-block' : 'none';
        });
      });
  }

  // (Optional cart drawer helper removed to reduce file size; keep implementation elsewhere if needed.)

  // Initial cart count update
  updateCartCount();
});

// Cosmic floating text effect (for banner)
document.addEventListener('DOMContentLoaded', function() {
  var floatText = document.querySelector('.banner__floating');
  if (floatText) {
    floatText.style.animation = 'floatText 3s infinite alternate';
  }
});

// Example: Fetch products from Storefront API

// Storefront API product loader with 'Load More' button
let storefrontProductsCursor = null;
let storefrontProductsContainer = null;
let storefrontLoadMoreBtn = null;

document.addEventListener('DOMContentLoaded', function() {
  // Use #main-collection-js as the target container for products and button
  let mainContent = document.getElementById('main-collection-js');
  if (!mainContent) {
    mainContent = document.createElement('section');
    mainContent.id = 'main-collection-js';
    document.body.appendChild(mainContent);
  }
  // Always clear the mainContent container on page load to prevent duplicate grids
  mainContent.innerHTML = '';
  storefrontProductsContainer = null;
  storefrontLoadMoreBtn = null;
  let storefrontProductsCursor = null;
  let productsLoaded = 0;
  function renderStorefrontProducts(products) {
    // Infinite scroll: only create storefrontProductsContainer if it doesn't exist
    const mainContent = document.getElementById('main-collection-js');
    if (!storefrontProductsContainer || !mainContent.contains(storefrontProductsContainer)) {
      storefrontProductsContainer = document.createElement('div');
      storefrontProductsContainer.id = 'storefront-products-container';
      storefrontProductsContainer.className = 'collection-list';
      storefrontProductsContainer.style.display = 'flex';
      storefrontProductsContainer.style.flexWrap = 'wrap';
      storefrontProductsContainer.style.gap = '1.2rem';
      storefrontProductsContainer.style.justifyContent = 'center';
      storefrontProductsContainer.style.padding = '1rem';
      storefrontProductsContainer.style.boxSizing = 'border-box';
      storefrontProductsContainer.style.width = '100%';
      mainContent.appendChild(storefrontProductsContainer);
    }
    const frag = document.createDocumentFragment();
    products.forEach(edge => {
      const product = edge.node;
      const card = document.createElement('div');
      card.className = 'collection-card';
      card.style.background = 'rgba(34,8,69,0.92)';
      card.style.borderRadius = '18px';
      card.style.boxShadow = '0 2px 16px #b23cf0';
      card.style.padding = '1.2rem';
      card.style.width = '100%';
      card.style.maxWidth = '320px';
      card.style.textAlign = 'center';
      card.style.margin = '0 auto';
      card.style.display = 'flex';
      card.style.flexDirection = 'column';
      card.style.alignItems = 'center';
      card.style.transition = 'box-shadow 0.2s';
      card.onmouseover = () => card.style.boxShadow = '0 4px 24px #ffe66f';
      card.onmouseout = () => card.style.boxShadow = '0 2px 16px #b23cf0';
      let imageHtml = '';
      if (product.featuredImage && product.featuredImage.url) {
        imageHtml = `<img src="${product.featuredImage.url}" alt="${product.title}" style="width:100%; max-width:260px; border-radius:14px; margin-bottom:1rem; box-shadow:0 0 16px #ffe66f; object-fit:cover;" loading="lazy">`;
      }
      const price = (product.priceRange && product.priceRange.minVariantPrice && product.priceRange.minVariantPrice.amount) ? Number(product.priceRange.minVariantPrice.amount).toFixed(2) : '';
      const currency = (product.priceRange && product.priceRange.minVariantPrice && product.priceRange.minVariantPrice.currencyCode) ? product.priceRange.minVariantPrice.currencyCode : '';
      let priceHtml = `<span style=\"color:#ffe66f; font-size:1.1rem; font-weight:bold;\">$${price} ${currency}</span>`;
      card.innerHTML = `
        ${imageHtml}
        <h2 style="color:#ffe66f; font-size:1.2rem; margin-bottom:0.5rem; font-weight:700;">${product.title}</h2>
        <p class="product-price" style="color:#ffe66f; font-size:1.1rem; margin:0.5rem 0; font-weight:600;">${priceHtml}</p>
        <div style="display:flex; flex-direction:row; gap:0.5rem; justify-content:center; margin-top:1rem; width:100%;">
          <a href="/products/${product.handle}" class="button button--primary" style="background:linear-gradient(90deg,#b23cf0 0%,#ffe66f 100%); color:#fff; border-radius:24px; padding:0.75rem 1.5rem; text-decoration:none; font-weight:bold; flex:1; font-size:1rem;">View Product</a>
        </div>
      `;
      frag.appendChild(card);
      productsLoaded++;
    });
    storefrontProductsContainer.appendChild(frag);
    // Ensure async decoding for images to reduce main-thread blocking
    const imgs = storefrontProductsContainer.querySelectorAll('img');
    imgs.forEach(i => { try { i.decoding = 'async'; } catch (e) {} });
  }

  // Fetch products from Storefront API
  function fetchStorefrontProducts() {
    if (__shouldSkipHeavyFetches()) return;
    let afterClause = storefrontProductsCursor ? `, after: \"${storefrontProductsCursor}\"` : '';
    let collectionHandle = null;
    if (window.location.pathname.includes('/collections/')) {
      // Extract collection handle from URL
      const match = window.location.pathname.match(/\/collections\/([^\/]+)/);
      if (match) {
        collectionHandle = match[1];
      }
    }
    let query;
    if (collectionHandle) {
      query = `{
        collectionByHandle(handle: \"${collectionHandle}\") {
          products(first: 9${afterClause}) {
            edges {
              node {
                id
                title
                handle
                description
                featuredImage { url }
                priceRange {
                  minVariantPrice {
                    amount
                    currencyCode
                  }
                }
              }
            }
            pageInfo { hasNextPage endCursor }
          }
        }
      }`;
    } else {
      query = `{
        products(first: 9${afterClause}) {
          edges {
            node {
              id
              title
              handle
              description
              featuredImage { url }
              priceRange {
                minVariantPrice {
                  amount
                  currencyCode
                }
              }
            }
          }
          pageInfo { hasNextPage endCursor }
        }
      }`;
    }
    fetch('https://eastcoastgemsbycara.myshopify.com/api/2023-07/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '80b6df7e56e9aed810c3acd41bdf7800'
      },
      body: JSON.stringify({ query })
    })
    .then(res => res.json())
    .then(data => {
      let products, pageInfo;
      // Debug: log full API response for collection
      // Removed debug logging to reduce console noise in production
      if (collectionHandle && (!data.data || !data.data.collectionByHandle)) {
        document.getElementById('main-collection-js').innerHTML = '<p style="color:#ffe66f; font-size:1.2rem; text-align:center; margin:2rem 0;">No products found for this collection.</p>';
        return;
      }
      if (!collectionHandle && (!data.data || !data.data.products)) {
        document.getElementById('main-collection-js').innerHTML = '<p style="color:#ffe66f; font-size:1.2rem; text-align:center; margin:2rem 0;">No products found.</p>';
        return;
      }
      if (collectionHandle && data.data.collectionByHandle) {
        products = data.data.collectionByHandle.products.edges;
        pageInfo = data.data.collectionByHandle.products.pageInfo;
      } else if (data.data.products) {
        products = data.data.products.edges;
        pageInfo = data.data.products.pageInfo;
      } else {
        console.error('Unexpected API response:', data);
        return;
      }
      renderStorefrontProducts(products);
      storefrontProductsCursor = pageInfo.hasNextPage ? pageInfo.endCursor : null;
      if (!storefrontLoadMoreBtn) {
        storefrontLoadMoreBtn = document.createElement('button');
        storefrontLoadMoreBtn.id = 'load-more-products';
        storefrontLoadMoreBtn.textContent = 'Load More';
        storefrontLoadMoreBtn.className = 'button button--primary';
        storefrontLoadMoreBtn.style.margin = '2rem auto';
        storefrontLoadMoreBtn.style.display = 'block';
        storefrontLoadMoreBtn.style.borderRadius = '24px';
        storefrontLoadMoreBtn.style.padding = '0.75rem 2rem';
        storefrontLoadMoreBtn.style.background = 'linear-gradient(90deg,#b23cf0 0%,#ffe66f 100%)';
        storefrontLoadMoreBtn.style.color = '#fff';
        storefrontLoadMoreBtn.style.fontWeight = 'bold';
        storefrontLoadMoreBtn.style.fontSize = '1.1rem';
        storefrontLoadMoreBtn.style.boxShadow = '0 2px 12px #b23cf0';
        storefrontLoadMoreBtn.style.border = 'none';
        storefrontLoadMoreBtn.onclick = function(e) {
          // Prevent default anchor/button behavior
          if (e) e.preventDefault();
          // Only load more products, do not scroll or focus
          fetchStorefrontProducts();
        };
        document.getElementById('main-collection-js').appendChild(storefrontLoadMoreBtn);
      }
      // Always move Load More button below products
      if (storefrontLoadMoreBtn && storefrontProductsContainer) {
        storefrontProductsContainer.parentNode.appendChild(storefrontLoadMoreBtn);
      }
      storefrontLoadMoreBtn.style.display = pageInfo.hasNextPage ? 'block' : 'none';
    });
  }

  // Load more products on button click
  function setupStorefrontLoadMore() {
    const loadMoreBtn = document.getElementById('load-more-products');
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function(e) {
        // Prevent default anchor/button behavior
        if (e) e.preventDefault();
        loadMoreBtn.disabled = true;
        loadMoreBtn.textContent = 'Loading...';
        fetchStorefrontProducts(storefrontProductsCursor);
        setTimeout(() => {
          loadMoreBtn.disabled = false;
          loadMoreBtn.textContent = 'Load More';
        }, 1000);
      });
    }
  }

  // Run product loader on all-products and collection pages
  if (window.location.pathname === '/collections/all' || window.location.pathname.startsWith('/collections/')) {
    fetchStorefrontProducts();
    if (!storefrontLoadMoreBtn) {
      storefrontLoadMoreBtn = document.createElement('button');
      storefrontLoadMoreBtn.id = 'load-more-products';
      storefrontLoadMoreBtn.textContent = 'Load More';
      storefrontLoadMoreBtn.className = 'button button--primary';
      storefrontLoadMoreBtn.style.margin = '2rem auto';
      storefrontLoadMoreBtn.style.display = 'block';
      storefrontLoadMoreBtn.style.borderRadius = '24px';
      storefrontLoadMoreBtn.style.padding = '0.75rem 2rem';
      storefrontLoadMoreBtn.style.background = 'linear-gradient(90deg,#b23cf0 0%,#ffe66f 100%)';
      storefrontLoadMoreBtn.style.color = '#fff';
      storefrontLoadMoreBtn.style.fontWeight = 'bold';
      storefrontLoadMoreBtn.style.fontSize = '1.1rem';
      storefrontLoadMoreBtn.style.boxShadow = '0 2px 12px #b23cf0';
      storefrontLoadMoreBtn.style.border = 'none';
      storefrontLoadMoreBtn.onclick = function() {
        fetchStorefrontProducts();
      };
      document.getElementById('main-collection-js').appendChild(storefrontLoadMoreBtn);
    }
  }
});

// Most Viewed Section
(function() {

  function recordView(handle) {
    try {
      let viewed = JSON.parse(localStorage.getItem('ecg_most_viewed')) || [];
      viewed.push({
        handle: handle,
        time: Date.now()
      });
      localStorage.setItem('ecg_most_viewed', JSON.stringify(viewed));
    } catch (e) {
      console.error('Most Viewed: Could not record view', e);
    }
  }

  function getRandomProducts(products, count) {
    let shuffled = products
      .map(p => ({ p, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(obj => obj.p);
    return shuffled.slice(0, count);
  }

  // Schedule rendering off the main loading path when possible
  function scheduleRender(fn) {
    if (window.requestIdleCallback) {
      try { window.requestIdleCallback(fn, { timeout: 500 }); } catch (e) { setTimeout(fn, 50); }
    } else {
      setTimeout(fn, 50);
    }
  }

  function renderMostViewed() {
    if (window.location.pathname.startsWith('/collections/')) return; // don't render random picks on collection pages
    const container = document.getElementById('most-viewed-products');
    if (!container) return;

    // Ensure responsive styles for the Most Viewed cards (mobile: 2x2 grid)
    if (!document.getElementById('ecg-most-viewed-styles')) {
      const style = document.createElement('style');
      style.id = 'ecg-most-viewed-styles';
      style.textContent = `
        /* layout: 2x2 on small, 4-per-row on desktop */
        #most-viewed-section, #most-viewed-products, #jewelry-section, #jewelry-products { margin-top: -1.25rem; }
        #most-viewed-products, #jewelry-products { display:flex; gap:1rem; justify-content:center; flex-wrap:wrap; width:100%; max-width:1200px; margin:0 auto; padding:0 1rem; box-sizing:border-box; }
        .most-viewed-card { box-sizing:border-box; flex:0 0 calc(50% - 1rem); max-width: calc(50% - 1rem); }
        .most-viewed-card img { width:100%; height:100%; object-fit:cover; }
        @media(min-width: 900px) {
          .most-viewed-card { flex:0 0 calc(25% - 1rem); max-width: calc(25% - 1rem); }
          #most-viewed-section, #most-viewed-products { margin-top: -1rem; }
        }
      `;
      document.head.appendChild(style);
    }

    // Fallback to Storefront GraphQL API instead of relying on
    // a theme JSON view at `/collections/all?view=json` which may not exist.
    // Query the 'all' collection and fetch up to 50 products (cached), then pick 4 at random
    const CACHE_KEY = 'ecg_all_products_v1';
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (__shouldSkipHeavyFetches() && !cached) return;
    if (cached) {
      try {
        const products = JSON.parse(cached);
        const selected = getRandomProducts(products, 4);
        scheduleRender(() => renderMostViewedFromNodes(selected));
        return;
      } catch (e) {
        sessionStorage.removeItem(CACHE_KEY);
      }
    }

    const query = `{
      collectionByHandle(handle: "all") {
        products(first:50) {
          edges {
            node {
              title
              handle
              onlineStoreUrl
              featuredImage { url altText }
              priceRange { minVariantPrice { amount currencyCode } }
            }
          }
        }
      }
    }`;

    fetch('https://eastcoastgemsbycara.myshopify.com/api/2023-07/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '80b6df7e56e9aed810c3acd41bdf7800'
      },
      body: JSON.stringify({ query })
    })
      .then(res => res.json())
      .then(data => {
        const edges = (data && data.data && data.data.collectionByHandle && data.data.collectionByHandle.products && data.data.collectionByHandle.products.edges) ? data.data.collectionByHandle.products.edges : [];
        if (!edges.length) return;
        const products = edges.map(e => e.node);
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(products)); } catch (e) {}
        const selected = getRandomProducts(products, 4);
        scheduleRender(() => renderMostViewedFromNodes(selected));
      })
      .catch(err => console.error('Most Viewed fetch error:', err));
  }

  // Render helper builds DOM nodes (safer than innerHTML and allows lazy loading)
  function renderMostViewedFromNodes(selected) {
    const container = document.getElementById('most-viewed-products');
    if (!container) return;
    // Render as compact listings (no images)
    container.innerHTML = '';
    const frag = document.createDocumentFragment();
    selected.forEach(product => {
      const img = product.featuredImage && product.featuredImage.url ? product.featuredImage.url : '';
      const price = product.priceRange && product.priceRange.minVariantPrice && product.priceRange.minVariantPrice.amount ? Number(product.priceRange.minVariantPrice.amount).toFixed(2) : '';
      const currency = product.priceRange && product.priceRange.minVariantPrice && product.priceRange.minVariantPrice.currencyCode ? product.priceRange.minVariantPrice.currencyCode : '';
      const url = product.onlineStoreUrl || `/products/${product.handle}`;

      const item = document.createElement('div');
      item.className = 'most-viewed-card';
      item.style.cssText = 'background:rgba(34,8,69,0.92); border-radius:12px; padding:0.8rem; text-align:center; margin-bottom:0.4rem; width:100%; box-sizing:border-box;';

      if (img) {
        const imgWrap = document.createElement('div');
        imgWrap.style.cssText = 'width:100%; max-width:260px; margin:0 auto 0.6rem; overflow:hidden; border-radius:10px;';
        const imgel = document.createElement('img');
        imgel.src = img;
        imgel.alt = product.title;
        imgel.loading = 'lazy';
        try { imgel.decoding = 'async'; } catch (e) {}
        imgel.style.cssText = 'width:100%; height:auto; object-fit:cover; display:block;';
        imgWrap.appendChild(imgel);
        item.appendChild(imgWrap);
      }

      const title = document.createElement('h3');
      title.style.cssText = 'color:#ffe66f;font-size:1rem;margin:0;font-weight:700;';
      title.textContent = product.title;
      item.appendChild(title);

      const meta = document.createElement('div');
      meta.style.cssText = 'display:flex; flex-direction:column; align-items:center; margin-top:0.5rem; gap:0.5rem;';

      const priceEl = document.createElement('span');
      priceEl.style.cssText = 'color:#ffe66f; font-weight:600;';
      priceEl.textContent = currency ? '$' + price + ' ' + currency : '';

      const viewLink = document.createElement('a');
      viewLink.href = url;
      viewLink.className = 'button button--primary';
      viewLink.style.cssText = 'background:linear-gradient(90deg,#b23cf0 0%,#ffe66f 100%); color:#fff; border-radius:14px; padding:0.35rem 0.75rem; text-decoration:none; font-weight:700;';
      viewLink.textContent = 'View';

      meta.appendChild(priceEl);
      meta.appendChild(viewLink);
      item.appendChild(meta);

      frag.appendChild(item);
    });
    container.appendChild(frag);

    // Add 'View All' button (link to /collections/all)
    const existingAll = document.getElementById('most-viewed-view-all');
    if (existingAll) existingAll.remove();
    const allBtn = document.createElement('a');
    allBtn.id = 'most-viewed-view-all';
    allBtn.href = '/collections/all';
    allBtn.textContent = 'View All';
    allBtn.className = 'button button--primary';
    allBtn.style.cssText = 'display:block; margin:1rem auto 0; width:max-content; padding:0.6rem 1.4rem; border-radius:24px; background:linear-gradient(90deg,#b23cf0 0%,#ffe66f 100%); color:#fff; font-weight:700; text-decoration:none;';
    container.parentNode && container.parentNode.appendChild(allBtn);
  }

  window.ecgMostViewed = { recordView: recordView, render: renderMostViewed };

  // Use an IntersectionObserver to render Most Viewed when visible
  function observeMostViewed() {
    if (window.location.pathname.startsWith('/collections/')) return; // avoid observing on collection pages
    const target = document.getElementById('most-viewed-section') || document.getElementById('most-viewed-products');
    if (!target) {
      // If the section isn't in DOM yet, try again once DOMContentLoaded fires
      document.addEventListener('DOMContentLoaded', function tryObserve() { document.removeEventListener('DOMContentLoaded', tryObserve); observeMostViewed(); });
      return;
    }
    const obs = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          renderMostViewed();
          observer.disconnect();
        }
      });
    }, { threshold: 0.1 });
    obs.observe(target);
  }
  observeMostViewed();

})(); 
// End of Most Viewed

// Jewelry Section (4 random products from the "jewelry" collection)
(function() {

  const CACHE_KEY = 'ecg_jewelry_products_v1';

  function getRandomProducts(products, count) {
    const shuffled = products
      .map(p => ({ p, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(obj => obj.p);
    return shuffled.slice(0, count);
  }

  // Schedule rendering off the main loading path when possible
  function scheduleRender(fn) {
    if (window.requestIdleCallback) {
      try { window.requestIdleCallback(fn, { timeout: 500 }); } catch (e) { setTimeout(fn, 50); }
    } else {
      setTimeout(fn, 50);
    }
  }

  function renderJewelryFromNodes(selected) {
    let container = document.getElementById('jewelry-products');
    if (!container) return;
    // Render jewelry as compact listings (no images)
    container.innerHTML = '';
    const frag = document.createDocumentFragment();
    selected.forEach(product => {
      const img = product.featuredImage && product.featuredImage.url ? product.featuredImage.url : '';
      const price = product.priceRange && product.priceRange.minVariantPrice && product.priceRange.minVariantPrice.amount ? Number(product.priceRange.minVariantPrice.amount).toFixed(2) : '';
      const currency = product.priceRange && product.priceRange.minVariantPrice && product.priceRange.minVariantPrice.currencyCode ? product.priceRange.minVariantPrice.currencyCode : '';
      const url = product.onlineStoreUrl || `/products/${product.handle}`;

      const item = document.createElement('div');
      item.className = 'most-viewed-card';
      item.style.cssText = 'background:rgba(34,8,69,0.92); border-radius:12px; padding:0.8rem; text-align:center; margin-bottom:0.4rem; width:100%; box-sizing:border-box;';

      if (img) {
        const imgWrap = document.createElement('div');
        imgWrap.style.cssText = 'width:100%; max-width:260px; margin:0 auto 0.6rem; overflow:hidden; border-radius:10px;';
        const imgel = document.createElement('img');
        imgel.src = img;
        imgel.alt = product.title;
        imgel.loading = 'lazy';
        try { imgel.decoding = 'async'; } catch (e) {}
        imgel.style.cssText = 'width:100%; height:auto; object-fit:cover; display:block;';
        imgWrap.appendChild(imgel);
        item.appendChild(imgWrap);
      }

      const title = document.createElement('h3');
      title.style.cssText = 'color:#ffe66f;font-size:1rem;margin:0;font-weight:700;';
      title.textContent = product.title;
      item.appendChild(title);

      const meta = document.createElement('div');
      meta.style.cssText = 'display:flex; flex-direction:column; align-items:center; margin-top:0.5rem; gap:0.5rem;';

      const priceEl = document.createElement('span');
      priceEl.style.cssText = 'color:#ffe66f; font-weight:600;';
      priceEl.textContent = currency ? '$' + price + ' ' + currency : '';

      const viewLink = document.createElement('a');
      viewLink.href = url;
      viewLink.className = 'button button--primary';
      viewLink.style.cssText = 'background:linear-gradient(90deg,#b23cf0 0%,#ffe66f 100%); color:#fff; border-radius:14px; padding:0.35rem 0.75rem; text-decoration:none; font-weight:700;';
      viewLink.textContent = 'View';

      meta.appendChild(priceEl);
      meta.appendChild(viewLink);
      item.appendChild(meta);

      frag.appendChild(item);
    });
    container.appendChild(frag);

    // Add 'View All' button (link to /collections/jewelry)
    const existingAll = document.getElementById('jewelry-view-all');
    if (existingAll) existingAll.remove();
    const allBtn = document.createElement('a');
    allBtn.id = 'jewelry-view-all';
    allBtn.href = '/collections/jewelry';
    allBtn.textContent = 'View All';
    allBtn.className = 'button button--primary';
    allBtn.style.cssText = 'display:block; margin:1rem auto 0; width:max-content; padding:0.6rem 1.4rem; border-radius:24px; background:linear-gradient(90deg,#b23cf0 0%,#ffe66f 100%); color:#fff; font-weight:700; text-decoration:none;';
    container.parentNode && container.parentNode.appendChild(allBtn);
  }

  function fetchJewelry() {
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (cached) {
      try {
        const products = JSON.parse(cached);
        const selected = getRandomProducts(products, 4);
        scheduleRender(() => renderJewelryFromNodes(selected));
        return;
      } catch (e) {
        sessionStorage.removeItem(CACHE_KEY);
      }
    if (__shouldSkipHeavyFetches()) return;
    }

    const query = `{
      collectionByHandle(handle: "jewelry") {
        products(first:50) {
          edges { node { title handle onlineStoreUrl featuredImage { url altText } priceRange { minVariantPrice { amount currencyCode } } } }
        }
      }
    }`;

    fetch('https://eastcoastgemsbycara.myshopify.com/api/2023-07/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '80b6df7e56e9aed810c3acd41bdf7800'
      },
      body: JSON.stringify({ query })
    })
      .then(res => res.json())
      .then(data => {
        const edges = (data && data.data && data.data.collectionByHandle && data.data.collectionByHandle.products && data.data.collectionByHandle.products.edges) ? data.data.collectionByHandle.products.edges : [];
        if (!edges.length) return;
        const products = edges.map(e => e.node);
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(products)); } catch (e) {}
        const selected = getRandomProducts(products, 4);
        scheduleRender(() => renderJewelryFromNodes(selected));
      })
      .catch(err => console.error('Jewelry fetch error:', err));
  }

  function ensureJewelrySection() {
    // Only add the jewelry section on the homepage. Avoid inserting it on other pages
    if (window.location.pathname !== '/' && window.location.pathname !== '') return null;
    let section = document.getElementById('jewelry-section');
    if (section) return section;
    const refSection = document.getElementById('most-viewed-section');
    const refProducts = document.getElementById('most-viewed-products');
    // If the Most Viewed section exists in the DOM, clone its structure to match exactly
    if (refSection) {
      section = refSection.cloneNode(true);
      section.id = 'jewelry-section';
      // Update heading text inside cloned section
      const h2 = section.querySelector('h2');
      if (h2) h2.textContent = 'Jewelry';
      // Replace products container id inside clone
      const clonedProducts = section.querySelector('#most-viewed-products');
      if (clonedProducts) {
        clonedProducts.id = 'jewelry-products';
        // clear any existing children so we'll render fresh items
        clonedProducts.innerHTML = '';
      } else {
        // if the clone lacks the expected container, create one
        const productsWrap = document.createElement('div');
        productsWrap.id = 'jewelry-products';
        productsWrap.className = 'most-viewed-products';
        section.appendChild(productsWrap);
      }
      // Insert clone after the original Most Viewed section
      refSection.parentNode.insertBefore(section, refSection.nextSibling);
      return section;
    }

    // Fallback: construct a section that mirrors the Most Viewed layout
    const ref = refProducts || document.getElementById('most-viewed-products');
    section = document.createElement('section');
    section.id = 'jewelry-section';
    section.style.cssText = 'padding:1rem 0;';

    const heading = document.createElement('h2');
    heading.textContent = 'Jewelry';
    heading.style.cssText = 'color:#ffe66f;text-align:center;margin-bottom:0.6rem;font-weight:700;';
    section.appendChild(heading);

    const productsWrap = document.createElement('div');
    productsWrap.id = 'jewelry-products';
    productsWrap.className = 'most-viewed-products';
    section.appendChild(productsWrap);

    if (ref && ref.parentNode) {
      ref.parentNode.insertBefore(section, ref.nextSibling);
    } else {
      const main = document.getElementById('main-collection-js');
      if (main) main.appendChild(section); else document.body.appendChild(section);
    }
    return section;
  }

  function renderJewelry() {
    if (window.location.pathname.startsWith('/collections/')) return; // don't render on collection pages
    ensureJewelrySection();
    fetchJewelry();
  }

  window.ecgJewelry = { render: renderJewelry };

  document.addEventListener('DOMContentLoaded', function() {
    const section = ensureJewelrySection();
    if (!section) return; // skip jewelry setup on collection pages
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          renderJewelry();
          obs.disconnect();
        }
      });
    }, { threshold: 0.1 });
    observer.observe(section);
  });

})();

// You May Also Like (3 random products from all collections) — product page only
(function() {
  function getRandomProducts(products, count) {
    const shuffled = products
      .map(p => ({ p, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(obj => obj.p);
    return shuffled.slice(0, count);
  }

  function scheduleRender(fn) {
    if (window.requestIdleCallback) {
      try { window.requestIdleCallback(fn, { timeout: 500 }); } catch (e) { setTimeout(fn, 50); }
    } else {
      setTimeout(fn, 50);
    }
  }

  function renderYouMayAlsoLike(selected) {
    const container = document.getElementById('you-may-also-like-products');
    if (!container) return;
    // Ensure styles so 3 cards appear on a single row (allow horizontal scroll on very small screens)
    if (!document.getElementById('ecg-you-may-also-like-styles')) {
      const style = document.createElement('style');
      style.id = 'ecg-you-may-also-like-styles';
      style.textContent = `
        /* Match Most Viewed sizing */
        #you-may-also-like-section, #you-may-also-like-products { margin-top: -1.25rem; }
        #you-may-also-like-products { display:flex; gap:1rem; justify-content:center; flex-wrap:wrap; width:100%; max-width:1200px; margin:0 auto; padding:0 1rem; box-sizing:border-box; }
        #you-may-also-like-products .collection-card { box-sizing:border-box; flex:0 0 calc(50% - 1rem); max-width: calc(50% - 1rem); }
        #you-may-also-like-products .collection-card img { width:100%; height:100%; object-fit:cover; }
        @media(min-width: 900px) {
          #you-may-also-like-products .collection-card { flex:0 0 calc(25% - 1rem); max-width: calc(25% - 1rem); }
          #you-may-also-like-products { margin-top: -1rem; }
        }
      `;
      document.head.appendChild(style);
    }

    container.innerHTML = '';
    const frag = document.createDocumentFragment();
    selected.forEach(product => {
      const img = product.featuredImage && product.featuredImage.url ? product.featuredImage.url : '';
      const url = product.onlineStoreUrl || `/products/${product.handle}`;

      const card = document.createElement('div');
      card.className = 'collection-card';
      card.style.cssText = 'background:rgba(34,8,69,0.8); border-radius:16px; box-shadow:0 2px 12px #b23cf0; padding:1.2rem; text-align:center; box-sizing:border-box;';

      if (img) {
        const imgEl = document.createElement('img');
        imgEl.src = img;
        imgEl.alt = product.title;
        imgEl.loading = 'lazy';
        try { imgEl.decoding = 'async'; } catch(e) {}
        imgEl.style.cssText = 'width:100%; height:auto; border-radius:12px; margin-bottom:1rem; box-shadow:0 0 16px #ffe66f; object-fit:cover;';
        card.appendChild(imgEl);
      }

      const h3 = document.createElement('h3');
      h3.style.cssText = 'color:#ffe66f; font-size:1.1rem; margin-bottom:0.5rem;';
      h3.textContent = product.title;
      card.appendChild(h3);

      const a = document.createElement('a');
      a.href = url;
      a.className = 'button button--primary';
      a.style.cssText = 'background:linear-gradient(90deg,#b23cf0 0%,#ffe66f 100%); color:#2a0845; border-radius:24px; padding:0.5rem 1.5rem; text-decoration:none; font-weight:700;';
      a.textContent = 'View Product';
      card.appendChild(a);

      frag.appendChild(card);
    });
    container.appendChild(frag);

    // No dynamic sizing: rely on stylesheet rules for consistent 3-per-row layout
  }

  function fetchAndRender() {
    if (!window.location.pathname.startsWith('/products/')) return;
    const container = document.getElementById('you-may-also-like-products');
    if (!container) return;

    const CACHE_KEY = 'ecg_all_products_v1';
    const cached = sessionStorage.getItem(CACHE_KEY);
    const currentHandle = (window.location.pathname.match(/\/products\/([^\/]+)/) || [null, null])[1];

    if (cached) {
      try {
        const products = JSON.parse(cached) || [];
        const filtered = products.filter(p => p.handle !== currentHandle);
        if (filtered.length >= 3) {
          const selected = getRandomProducts(filtered, 3);
          scheduleRender(() => renderYouMayAlsoLike(selected));
          return;
        }
        // Not enough cached products — fall through to fetch fresh data
      } catch (e) { sessionStorage.removeItem(CACHE_KEY); }
    if (__shouldSkipHeavyFetches()) return;
    }

    // Fetch up to 200 products by paging through the Storefront API in small batches
    // Smaller batches and short yields reduce main-thread blocking for TTI/TBT.
    const MAX_PRODUCTS = 200;
    const BATCH_SIZE = 50; // reduced batch size to avoid long tasks

    function fetchProductsPage(after) {
      const afterClause = after ? `, after: \"${after}\"` : '';
      const query = `{
        collectionByHandle(handle: "all") {
          products(first:${BATCH_SIZE}${afterClause}) {
            edges { node { title handle onlineStoreUrl featuredImage { url altText } priceRange { minVariantPrice { amount currencyCode } } } }
            pageInfo { hasNextPage endCursor }
          }
        }
      }`;
      return fetch('https://eastcoastgemsbycara.myshopify.com/api/2023-07/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '80b6df7e56e9aed810c3acd41bdf7800'
        },
        body: JSON.stringify({ query })
      }).then(res => res.json());
    }

    // Accumulate pages until we have enough or there are no more
    (async function loadAll() {
      try {
        let allProducts = [];
        let after = null;
        do {
          const data = await fetchProductsPage(after);
          // if an audit requests skipping heavy fetches, stop fetching more pages
          if (__shouldSkipHeavyFetches()) break;
          const productsNode = data && data.data && data.data.collectionByHandle && data.data.collectionByHandle.products;
          if (!productsNode) break;
          const edges = productsNode.edges || [];
          const nodes = edges.map(e => e.node);
          allProducts = allProducts.concat(nodes);
          if (allProducts.length >= MAX_PRODUCTS) break;
          const pageInfo = productsNode.pageInfo || {};
          if (pageInfo && pageInfo.hasNextPage) {
            after = pageInfo.endCursor;
          } else {
            after = null;
            break;
          }
          // yield briefly to the main thread so long loops don't starve rendering
          await new Promise(function(res){ setTimeout(res, 50); });
        } while (after);

        if (!allProducts.length) return;
        // Trim to MAX_PRODUCTS
        if (allProducts.length > MAX_PRODUCTS) allProducts = allProducts.slice(0, MAX_PRODUCTS);
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(allProducts)); } catch (e) {}
        const filtered = allProducts.filter(p => p.handle !== currentHandle);
        const selected = getRandomProducts(filtered, 3);
        scheduleRender(() => renderYouMayAlsoLike(selected));
      } catch (err) {
        console.error('YouMayAlsoLike fetch error:', err);
      }
    })();
  }

  document.addEventListener('DOMContentLoaded', function() {
    fetchAndRender();
  });

})();
